<template>
    <div>
      <div>
         <img src="./../assets/banners (1).png" :style="{'margin-left':'40px','padding':'15px', 'height':'160px'}" alt="Company Logo">
      
      </div>
    </div>
  </template>
  
  <style>
  #navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f1f1f1;
    padding: 15px 20px;
  }
  
  #navbar .logo {
    height: 50px;
    width: auto;
  }
  
  #navbar ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
  }
  
  #navbar li {
    padding: 0 10px;
  }
  
  #navbar a {
    text-decoration: none;
    color: #333;
  }
  </style>